import React, { useContext } from 'react'
// NAVIGATION
import { useNavigate } from 'react-router-dom'
// CONTEXT
import { AppContext } from '../../../App'
// IMAGES
import imageCalendar from '../../../images/calendargif.gif'
import imageSiteWeb from '../../../images/imagesiteweb.png'
import imageServices from '../../../images/service.png'
import imagePush from '../../../images/imagepush.png'
import imageProfil from '../../../images/imageprofil.png'
import imageForfait from '../../../images/imageforfait.png'
import imageChat from '../../../images/chat.png'
import imageChatGif from '../../../images/chatgif.gif'
import imageClients from '../../../images/clients.png'
import imageStaff from '../../../images/staff.png'
import imageHoraires from '../../../images/horaires.png'

const ViewButtonsEquipe = ({ messagesChat }) => {
    let navigate = useNavigate()
    const { user } = useContext(AppContext)

    return (
        <div>

            {/* CARD PLANNING */}
            <div className='mt-3' onClick={() => navigate('/planningEquipe')}>
                <div className='card-body bg-white shadow rounded-2'>
                    <div className='text-center'>
                        <img src={imageCalendar} className='img-fluid' alt='image calendar' style={{ height:50, width:50 }} />
                        <div className='text-center' style={{fontSize:12}}>PLANNING</div>
                    </div>
                </div>
            </div>

            {/* AFFICHAGE BOUTONS HORAIRES / VACANCES */} 
            <div className='row text-center mt-4'>

                {/* HORAIRES */}
                <div className='col-6' onClick={() => navigate('/horairesEquipe')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginRight:-3}}>
                        <div className='text-center'>
                            <img src={imageHoraires} className='img-fluid' alt='image horaires' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>HORAIRES</div>
                        </div>
                    </div>
                </div>

                {/* VACANCES */}
                <div className='col-6' onClick={() => navigate('/vacancesEquipe')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginRight:-3}}>
                        <div className='text-center'>
                            <img src={imageHoraires} className='img-fluid' alt='image horaires' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>VACANCES</div>
                        </div>
                    </div>
                </div>

            </div>

            {/* AFFICHAGE CHAT / PROFIL */} 
            <div className='row text-center mt-4'>
 
                {/* BOUTTON MESSAGES */}
                <div className='col-6' onClick={() => navigate('/chatEquipe')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginLeft:-3}}>
                        <div className='text-center'>
                                    {/* TEST IS NEW CHAT*/}
                                {messagesChat
                                    .filter(mes => mes.uidClient === user.uid && mes.receiver === 'client' && mes.isNew)
                                    .map(mes => mes.id).length != 0 ? 
                                        <img src={imageChatGif} className='img-fluid' alt='image message' style={{ height:50, width:50 }} />
                                    : 
                                        <img src={imageChat} className='img-fluid' alt='image message' style={{ height:50, width:50 }} />
                                    }
                            
                            <div className='text-center' style={{fontSize:12}}>CHAT</div>
                        </div>
                    </div>
                </div>

                {/* PROFIL */}
                <div className='col-6' onClick={() => navigate('/profilEquipe')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginRight:-3}}>
                        <div className='text-center'>
                            <img src={imageProfil} className='img-fluid' alt='image profil' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>PROFIL</div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default ViewButtonsEquipe